const rename = { companyName: 'Company', uniqueRegistrationNumber: 'RegistrationNumber', osAccess: 'OSAccess',
  assignedClubs: 'Clubs', clientType: 'ClientType' }
const fieldName = path => {
  const [root, key, child] = path.split('.')
  if (['ownerInfo', 'contactInfo', 'organizerInfo'].includes(root)) {
    if (root === 'contactInfo' && key === 'website') return 'website'
    return root.replace('Info', '') + (rename[key] || (key ? key.charAt(0).toUpperCase() + key.slice(1) : 'FirstName'))
  }
  if (root === 'location') return 'location'
  if (root === 'bookingSettings') return key || 'bookingAccess'
  if (root === 'courtsInfo') return key + (child === 'courtTypes' ? 'Surfaces' : 'Courts')
  if (root === 'openHours') return key + ({ startTime: 'Start', endTime: 'End' }[child] || 'State')
  if (root === 'exclusiveOffer') return { startDate: 'offerstartDate', endDate: 'offerendDate', status: 'offerStatus' }[key]
    || (['weekday', 'weekend'].includes(key) && child ? key + child : 'offerStatus')
  if (root === 'communicationPreferences') return key
  if (root === 'profilePicture') return 'photo'
  return root
}

export const profileValidationFields = code => {
  const match = /^INVALID_(CLUB|PLAYER|PROFILE):([\w.,-]+)$/.exec(code || '')
  if (!match) return []
  return [...new Set(match[2].split(','))].flatMap(path => {
    const media = /^(?:defaultEventImages\.([\w-]+)\.(logo|featured|cover)|(logoImage|coverImage))$/.exec(path)
    const ids = media ? ['club-media-' + (media[3] || media[1] + '-' + media[2])]
      : ['club-', 'player-', 'admin-', 'editor-'].map(prefix => prefix + fieldName(path))
    const element = ids.map(id => document.getElementById(id)).find(Boolean)
    const label = element?.labels?.[0]?.textContent || element?.getAttribute('aria-label')
    return element && label ? [{ id: element.id, label: label.replace(/\s*\*\s*$/, '').trim() }] : []
  })
}

export const focusProfileField = id => {
  const element = document.getElementById(id)
  for (let parent = element?.parentElement; parent; parent = parent.parentElement) {
    if (parent.tagName === 'DETAILS') parent.open = true
  }
  element?.focus()
}
